// extracted by mini-css-extract-plugin
module.exports = {"BlueFont":"layout-module--BlueFont--1UUxB","container":"layout-module--container--2TGku","main":"layout-module--main--2yme8"};